import React, { useEffect, useState, useContext } from "react";
import Navbar from "../../../layout/Navbar/Navbar";
import Sidebar from "../../../layout/Sidebar/SideBar";
import Context from "../../../context/Context";
import language from "../../../nls/language.json";
import blogFetch from "../../../axios/config";
import CardConfig from "./CardConfig";
import { Button } from "@mui/material";
import toast from "react-hot-toast";
import Loading from "../../../components/Loading";
import LoadingButton from "@mui/lab/LoadingButton";
import { Col, Container, Row } from "react-bootstrap";

export default function ConfigPieceSector() {
    const [loading, setLoading] = useState(false);
    const [dataConfig, setDataConfig] = useState({
        data: [],
        CorHP_CorPreta: [],
        CorHP_Vermelhas: []
    });

    const {
        getStatusSideBar,
        selectedCountry,
        setLoadingFullScreen,
        loadingFullScreen,
        itemsPriority,
        setItemsPriority,
        setInputValue,
        inputValue
    } = useContext(Context);

    useEffect(() => {
        getGestaoPCPRegras();
    }, []);

    const getGestaoPCPRegras = async () => {
        try {
            setLoadingFullScreen(true);
            const { data } = await blogFetch.get('/ISAGA_GestaoPCPRegras');
            setDataConfig({
                data,
                CorHP_CorPreta: data.filter(item => item.regra_Tipo === 'CorHP_CorPreta'),
                CorHP_Vermelhas: data.filter(item => item.regra_Tipo === 'CorHP_Vermelhas')
            });
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoadingFullScreen(false);
        }
    }


    console.log("DataConfig: ", dataConfig);
    

    const putGestaoPCPRegras = async (params) => {
        if (!params)
            return
        try {
            setLoading(true);
            await blogFetch.put('/ISAGA_GestaoPCPRegras', params);

            getGestaoPCPRegras();
            toast.success(language[selectedCountry.name].Config.pecasSetor.notification.successUpdate, {
                duration: 4000,
            });
        } catch (error) {
            console.error(error);
            toast.error(language[selectedCountry.name].Config.pecasSetor.notification.errorUpdate, {
                duration: 4000,
            });
        }
        finally {
            setLoading(false);
        }
    }

    const createRestricoes = async (itemsPriority) => {
        try {
            await blogFetch.post(`/ISAGA_GestaoPCP_Resticoes/`, itemsPriority);
        } catch (error) {
            console.error(error)
        }
        finally {
            setInputValue('')
            setItemsPriority([])
        }
    }

    const handleEditConfig = ({ target }, type, key) => {
        const { name, value } = target;
        switch (type) {
            case 'string':
                setDataConfig({
                    ...dataConfig,
                    [key]: dataConfig[key].map(item => {
                        return item.regra_Nome === name ? {
                            ...item,
                            regra_Valor: value
                        } : item
                    })
                });
                break;
            case 'integer':
                if (!Number.isNaN(Number(value)))
                    return setDataConfig({
                        ...dataConfig,
                        [key]: dataConfig[key].map(item => {
                            return item.regra_Nome === name ? {
                                ...item,
                                regra_Valor: value ? value : "0"
                            } : item
                        })
                    });
                toast.error(language[selectedCountry.name].Config.pecasSetor.notification.errorUpdateNumber, {
                    duration: 4000,
                });
                break;
            case 'multiselect':
                setDataConfig({
                    ...dataConfig,
                    [key]: dataConfig[key].map(item => {
                        return item.regra_Nome === name ? {
                            ...item,
                            regra_Valor: value.join(';')
                        } : item
                    })
                });
                break;
            case 'checkbox':
                setDataConfig({
                    ...dataConfig,
                    [key]: dataConfig[key].map(item => {
                        return item.regra_Nome === name ? {
                            ...item,
                            regra_Valor: value ? "1" : "0"
                        } : item
                    })
                });
                break;
        }
    }

    return (
        <>
            <Navbar />
            <Sidebar />
            <div className={`app_body ${getStatusSideBar()}`}>
                <Container fluid>
                    <h1 className="title_tables">
                        {language[selectedCountry.name].Config.pecasSetor.title}
                    </h1>
                    {!loadingFullScreen && dataConfig?.data.length ? (
                        <div>
                            <Row>
                                <Col>
                                    <CardConfig
                                        data={dataConfig.CorHP_CorPreta}
                                        handleEditConfig={handleEditConfig}
                                    />
                                </Col>
                                <Col>
                                    <CardConfig
                                        data={dataConfig.CorHP_Vermelhas}
                                        handleEditConfig={handleEditConfig}
                                    />
                                </Col>
                            </Row>
                            <div className="d-flex justify-content-end mt-3 btn-atualizar">
                                <LoadingButton
                                    loading={loading}
                                    variant="contained"
                                    classNames="btn-atualizar"
                                    onClick={() => {
                                        putGestaoPCPRegras([
                                            ...dataConfig.CorHP_CorPreta,
                                            ...dataConfig.CorHP_Vermelhas
                                        ])
                                        createRestricoes(itemsPriority)
                                    }}
                                    className="updateButton"
                                >
                                    {language[selectedCountry.name].Config.pecasSetor.btnAtualizar}
                                </LoadingButton>
                            </div>
                        </div>
                    ) : <Loading />}
                </Container>
            </div>
        </>
    );
}
